$.fn.SameHeightRows = function(index) {
  let self = this

  self.closest('.row')
  if (!self.closest('.row').hasClass('--init')) {
    self = self.closest('.row')
    self.min_height = 0
    self.find('.col-colored .text-content').each(function() {
      if ($(this).outerHeight() > self.min_height) {
        self.min_height = $(this).outerHeight()
      }
    })
    self.css('--min-height', self.min_height + 'px')

    self.addClass('--init')
  }

  return function() {
    return self
  }()
}
